import { render, staticRenderFns } from "./PayrollCommandProcess.vue?vue&type=template&id=1bb71ec9"
import script from "./PayrollCommandProcess.vue?vue&type=script&lang=js"
export * from "./PayrollCommandProcess.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports